import { Arc } from 'd3-shape';
import { DefaultArcObject } from 'd3-shape';
import { arc } from 'd3-shape';
import React from 'react';

// This method is a work-around for this issue: https://github.com/d3/d3-shape/issues/198
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const generateArc = <G extends DefaultArcObject, T = any>(
  arc: Arc<T, G>,
): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const arcAny = arc as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return arcAny()!;
};

const width = 175;
const height = 135;
const innerRadius = 157;
const outerRadius = 167;
const cornerRadius = 4;
const startAngle = -1 * (Math.PI / 3) * 2;

export const OverviewGauge = (props: {
  percentage: number;
  fillColor: string;
  content?: React.ReactNode;
}) => {
  const { percentage, fillColor, content } = props;

  const staticArc = arc()
    .innerRadius(innerRadius)
    .outerRadius(outerRadius)
    .cornerRadius(cornerRadius)
    .startAngle(startAngle)
    .endAngle((Math.PI / 3) * 2);

  // our start angle for the fill is always -135 degrees but we need the end angle to be dynamic
  const fillEndAngle =
    startAngle + (Math.PI / 3 * 4) * Math.max(0.0, Math.min(1, percentage));

  const fillArc = arc()
    .innerRadius(innerRadius)
    .outerRadius(outerRadius)
    .cornerRadius(cornerRadius)
    .startAngle(startAngle)
    .endAngle(fillEndAngle);

  return (
    <div className="flex flex-col justify-between items-center">
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width * 2} ${height* 2}`}
        className={'mt-4'}
      >
        {/* Moves svg to center */}
        <g transform={`translate(${width}, ${width})`}>
          <path d={generateArc(staticArc)} fill="#D9D9D9" />
          <path d={generateArc(fillArc)} fill={fillColor} />
        </g>
      </svg>
      <div>{content}</div>
    </div>
  );
};
